export const emails = state => state.emails
